import { ReactElement } from 'react';
import RCALogo from './RCALogo';
import BurgerButton from './BurgerButton';
import NavigationLinks from './NavigationLinks';
import { Login } from './Login';
import styled from 'styled-components';
import { Account } from './Account';
import { setTrackingSource } from './utils/tracking/trackingUtils';
import { usePageName } from '@rea-argonaut/analytics-react';

const Wrapper = styled.div`
  height: 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 99;
  ${({ theme }) => theme.layoutBreakpoints.extraLarge} {
    height: 100%;
  }
`;

const LoginWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  flex-grow: 1;
`;

type HeaderContentProps = {
  currentPage: string;
  signedInStatus: boolean | null;
  toggleMenu: () => void;
  isMenuOpen: boolean;
};

const HeaderContent = ({
  currentPage,
  signedInStatus,
  toggleMenu,
  isMenuOpen,
}: HeaderContentProps): ReactElement => {
  const pageName = usePageName();
  const isSignedInLoading = !!(signedInStatus === null);

  const setClickThroughSource = (element: string): void => {
    setTrackingSource({
      page: pageName,
      element: element,
    });
  };

  return (
    <Wrapper>
      <BurgerButton handleButtonClick={toggleMenu} isMenuOpen={isMenuOpen} />
      <RCALogo trackLinkClickThrough={setClickThroughSource} />
      <NavigationLinks
        currentPage={currentPage}
        isToggled={isMenuOpen}
        trackLinkClickThrough={setClickThroughSource}
      />
      <LoginWrapper>
        {isSignedInLoading ? (
          <></>
        ) : signedInStatus ? (
          <Account trackClickThrough={setClickThroughSource} />
        ) : (
          <Login
            currentPage={currentPage}
            trackClickThrough={setClickThroughSource}
          />
        )}
      </LoginWrapper>
    </Wrapper>
  );
};

export default HeaderContent;
